import CreateHttpClient from './createTimetablesWebApiHttpClient';
import { AxiosInstance } from 'axios';

import Department from '../models/department';

class DepartmentsApi {
    private httpClient: AxiosInstance;

    constructor() {
        this.httpClient = CreateHttpClient();
    }

    async GetDepartments(schoolId: number, campusId: number) {
        const { data } = await this.httpClient.get(`/department?schoolId=${schoolId}`);
        return data;
    }

    async GetDepartmentsBySchoolTerm(schoolId: number, termId: number) {
        const { data } = await this.httpClient.get(`/department/departmentTerm?schoolId=${schoolId}&termId=${termId}`);
        return data;
    }

    async UpdateDepartmentTerm(department: Department) {
        const payload = {
            ...department,
        };

        const { data } = await this.httpClient.put(`/department/departmentTerm`, payload);
        return data;
    }
}

export default DepartmentsApi;
